var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRf6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_874_613)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 14,
    fill: "url(#pattern0_874_613)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_874_613",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_874_613",
    transform: "scale(0.025641 0.0208333)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_874_613"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 14,
    fill: "white"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_874_613",
    width: 39,
    height: 48,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACcAAAAwCAQAAAA4eaudAAADSUlEQVRIx+1XW0gUYRTe8pt1UxZC06VSvPQgBEKZ3RSKoBtdqHyJQoXCoowiiu6K0UNCEJUVFmj0UElUDxkplWWoFJQpEXYRDMW0tHuhbO3q9O3OxZndmQ2dnqQ57Oz5z/+db2bOfv+Zf202+RBS8AOiagPYYrNyYClJKlEim4gz1umWqaPBf0HXhVbZrN6dEI0mktxHNe0bvgjzbNYOFEEUov3eYzy12UY33RGIjvF+rwFN1unOwy17N9Blne4W3speCbyuMKt0L9Age/sh2hOCEfaJSDc2ITmQLJ6qK5b9TPpBa3b2WHzWrGq9DQhJerodDM5UE9/jbpDQE4m4hFwDK+bMKj1dAzrFMeqoFB7EBNz/QiZlGZZpCmd2a688jYGjGkAGxwUBSVsZSzWic4XhN85poRfhESbrkp+g2yHoIscx6Igw+RnfoGZo4IIbVwIA63kv2bpIJd6ZquI2OoYGh5k6Sw9wCGxXjbqUl6g1pTuJAadDSezBIwPIQV4kQyMTtw+HZ9TnA6ZvRBrCVex2YqdKbhbdDQZ0Lr4xynUy6WFF69kTX8PrV5uHNWvhp5tIRSqsiUfqJEGEdfgZHmkkE6eDayEPp3GHVoXrKJelEjGOD1FjUpGdBK38m0xUqZT6YIsIyzcG2RM4d0qmo/IFZ4gV34YqucvpFacDNSudz9cWhEkh6HpR4fu6ht4QoAvol5YeVvNOl5vi4jhbJLWl+hB0+5RWJThZ48umuL2kS/c5H3CV5/k4FGR5jOfIMB/yDOUww5AsBp9QJ7l9KOO5xaiLCcn+R1ygJnWjA3GBZOGR1KIbaRJIRAnPrVS6S2cHSJeCJdqKYS6+sxPqKsi18ZyizlGGCl11wANs89Mt5vwKTXQ6XjHSiEKs5WrahXvczfQo2hw2HbVo50wzSaSCtKHIHqVNGyadvIKdqEW3MCH4VxkRHedvot0o/J9utNM95C5FawVW6IxbQNJI6TKxJ8hyGR8ZnWlbNKBDLNbgGDtLP84iW0i0QGeP4k7lF2Ne7hHa+fYS2QwqNHs7/1+TTaZ2QkuHdfjKcR/fL/n+2c0oYx8WeYFCBfLRdEep2ByVrtMU40Ws1GqikRrKtJtUtnczXLyE+AMxCLgwcvABAgAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRf6);
export default __webpack_public_path__ + "static/media/rf6.741ff95885c4116cc4143232a0bd2133.svg";
export { ForwardRef as ReactComponent };